import React from "react";
import { useAppSelector } from "../app/hooks";
import AppDrawer from "../components/muidrawer/Drawer";
import CreateMenu from "./menu/CreateMenu";
import CreateRights from "./rights/CreateRights";
import CreateCMS from "./cms/CreateCMS";
import CreateTestimonial from "./testimonial/CreateTestimonial";
import CreateUniform from "./uniform/CreateUniform";
import CreateClientLogo from "./clientlogo/CreateClientLogo";

import CreateCity from "./city/CreateCity";
import CreateState from "./state/CreateState";
import CreateCountry from "./country/CreateCountry";
import CreateRegion from "./region/CreateRegion";
import CreateCurrency from "./currency/CreateCurrency";
import CreateGst from "./gst/CreateGst";
import CreateRoomType from "./roomtype/CreateRoomType";
import CreateSpecialityType from "./specialitytype/CreateSpecialityType";
import CreateVehicleSharingPax from "./vehiclesharingpax/CreateVehicleSharingPax";
import CreateFestivals from "./festival/CreateFestivals";
import CreateItineraryFacility from "./ItineraryFacility/CreateItineraryFacility";
import CreateSetting from "./setting/CreateSetting";
import CreateOurExpertise from "./ourexpertise/CreateOurExpertise";

const Drawers = () => {
  const isDrawerOpen = useAppSelector((state) => state.muidrawer.open);
  const drawerName = useAppSelector((state) => state.muidrawer.name);

  //   ***********Note : Here you need to add key as a form name same which you passed from create Button***********

  const drawerComponents: Record<string, React.JSX.Element> = {
    cmsForm: <CreateCMS />,
    menuForm: <CreateMenu />,
    rightsForm: <CreateRights />,
    testimonialForm: <CreateTestimonial />,
    uniformForm: <CreateUniform />,
    clientLogoForm: <CreateClientLogo />,
    cityForm: <CreateCity />,
    countryForm: <CreateCountry />,
    stateForm: <CreateState />,
    regionForm: <CreateRegion />,
    currencyForm: <CreateCurrency />,
    gstForm: <CreateGst />,
    roomTypeForm: <CreateRoomType />,
    specialityTypeForm: <CreateSpecialityType />,
    vehicleSharingPaxForm: <CreateVehicleSharingPax />,
    festivalsForm: <CreateFestivals />,
    itineraryFacilityForm: <CreateItineraryFacility />,
    settingForm: <CreateSetting />,
    ourExpertiseForm: <CreateOurExpertise />,
  };

  return (
    <>
      {isDrawerOpen && Object.keys(drawerComponents).includes(drawerName) && (
        <AppDrawer>{drawerComponents[drawerName]}</AppDrawer>
      )}
    </>
  );
};

export default Drawers;
